import axios from "axios";

var PricingMode = {
    initializeHeaders: function (headers) {
        axios.defaults.headers.common = headers;
    },
    get: function () {
        return axios.get(Apollo.resolveApiUrl("~/pricingmode"), {});
    },
    query: function (benefitId) {
        return axios.get(
            Apollo.resolveApiUrl("~/pricingmode/query/" + benefitId.toString()),
            {
            });
    }
};

export default PricingMode;



// WEBPACK FOOTER //
// ./src/models/PricingMode.js